import { ActualDataTuple, LoginError, LoginErrorCodes, ThirdPartyCientAuthData } from "../../../login/data/LoginData.js";
import { PostMessageProxyPromise } from "@ciaopeople/cp-shatsu/RemoteService";
import { FBManualFlowCommons } from "./FBManualFlowCommons.js";
import { debug } from "../../LoginDbg.js";
import { hasOwnProperty } from "@ciaopeople/cp-shatsu/Utils";
import { isFunction } from "@ciaopeople/cp-shatsu/TypeChecking";
import { tryToPromise } from "../../../shared.js";
import { SessionStorageInterface } from "../../../session/SessionStorageInterface.js";



class FacebookManualFlowRemotePart extends FBManualFlowCommons {
    
    
       

    private initPromise: Promise<any> = null; 

    constructor(private readonly proxy: PostMessageProxyPromise,
        private readonly sessionStorage: SessionStorageInterface,
        public readonly appId: string, 
        scopes: string[] = []) {

        super(scopes);
        this.proxy.register(this.proxyMethodNames.getSessionDataForAutologin,() => this.getSessionDataForAutologin());
        this.proxy.register(this.proxyMethodNames.eventuallyHandleRevoke,(h,dr) => this.eventuallyHandleRevoke(h,dr));
       
    }   


    preloadAction(): Promise<void> {
        return Promise.resolve();
    }
    
    getSessionDataForAutologin(): Promise<ThirdPartyCientAuthData> {
        
        //crare redirect sdk che manca
        return this.sessionStorage.getFacebookLoginToken().then(existingToken => {

            if(existingToken && existingToken != "" && existingToken != "cancel") {
                debug.write("Existing FacebookToken in cookies .... trying with that", existingToken);
                return tryToPromise(
                    () => {
                        return new ThirdPartyCientAuthData(
                            null,
                            new ActualDataTuple(this.providerId, existingToken)
                        );
                    },
                    e =>  new LoginError(LoginErrorCodes.UNSPECIFIED_ERROR, "Invalid auth data", e)
                ).then(r => {
                    this.sessionStorage.clearFacebookLoginToken();
                    return r;
                });
            }
            else {
                debug.write("Missing FacebookToken in cookies ... going for getLoginStatus")
                return this.sdkInit().then(facebook => {
                    return new Promise((outResolve, outReject) => {
                        facebook.getLoginStatus(resp => {
                            debug.write("Facebook.getLoginStatus response", resp);
                            if(resp.status == "connected" && resp.authResponse) {
                                tryToPromise(
                                    () => {
                                        return new ThirdPartyCientAuthData(null,
                                            new ActualDataTuple(this.providerId, resp.authResponse.accessToken));
                                    },
                                    e => new LoginError(LoginErrorCodes.NO_SESSION_FOUND, "Invalid auth data", e)
                                ).then(
                                    out => outResolve(out)
                                ).catch(
                                    err => outReject(err)
                                );
                            }
                            else outReject(new LoginError(LoginErrorCodes.NO_SESSION_FOUND, "No session available", resp));
                            
                        }, true);
                    });    
                });
            }
            

        });
       
    }
    promptLogin(): Promise<ThirdPartyCientAuthData> {
        return this.proxy.invoke(this.proxyMethodNames.promptLogin);
    }
    oneTapLogin(): Promise<ThirdPartyCientAuthData> {
        return this.proxy.invoke(this.proxyMethodNames.oneTapLogin);
    }
    eventuallyHandleRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean> {
        if(isDeleteRequest) {
            debug.write("FB - Going for logout");
            return this.sdkInit().then(facebook => {
                return new Promise<boolean>((resolve) => {
                    try {
                        facebook.getLoginStatus(resp => {
                            debug.write("Facebook.getLoginStatus response", resp);
                            if(resp.status == "connected") {
                                facebook.logout(resp => {
                                    debug.write("FB - LOGOUT response", resp);
                                    resolve(true);
                                });
                            }
                            else resolve(true);
                        });
                        
                    } 
                    catch(e) {
                        debug.write("FB - there was an error during logout", e);
                        resolve(false);
                    }
                });
            }).catch(_e => {
                return Promise.resolve(false);
            });
        } 
        else {
            debug.write("FB - Nothing to delete on request");
            return Promise.resolve(true);
        }
    }

    private sdkInit(): Promise<any> {
        
        if(this.initPromise == null) {
            debug.write("Checking for pre existing initialized sdk", window['FB']);
            const fbAlreadyLoaded = hasOwnProperty(window, 'FB') && isFunction(window['FB']['init']);
            this.initPromise = new Promise((mainResolve) => {
                const initFunc = () => {
                    window['FB'].init({
                        appId: this.appId,
                        xfbml: false,
                        version: "v20.0",
                        status: true,
                        cookie: true
                    });
                    mainResolve(window['FB']);
                };
                if(fbAlreadyLoaded) {
                    debug.write("already loaded resolving directly");
                    initFunc();
                }
                else {
                    debug.write("attaching to fbAsyncInit");
                    window['fbAsyncInit'] = initFunc;
                }
                
            });
            if(!fbAlreadyLoaded) {
                debug.write("Fb not loaded ... now downloading");
                (function (d, id) {
                    const fjs = d.getElementsByTagName('script')[0];
                    if (d.getElementById(id)) {
                        return; 
                    }
                    const js: HTMLScriptElement = d.createElement('script');
                    js.id = id;
                    js.src = "//connect.facebook.net/it_IT/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'facebook-jssdk'));
            }
        }
        return this.initPromise;
    }

}

export { FacebookManualFlowRemotePart };